module.exports = "<i [icon]=\"symbol\"></i>\n<h1>{{title}}</h1>\n<p><ng-content></ng-content></p>\n"